export interface IAIPriceList {
  id: any;
  createdOnUtc: any;
  price: number;
  dimension: string;
  code: string;
  interval: number;
  model: string;
  type: string;
  groupName?: string;
  //key is code and value is price
  dictionary?: { [key: string]: number; }
  displayName?:string;
  list?: IAIPriceList[];
}

export enum EditType {
  None,
  BasePrice,
  AssistantPrice
}

export interface IAiAssistantPriceListGroup {
  model: string;
  interval: number;
  list: IAIPriceList[];
}

//the price codes of the AI models, in the order they are displayed for a model
export const ModelPriceCodes = [
  'AskGenerativeAIInput', 'AskGenerativeAIInputCached', 'AskGenerativeAIOutput', 'AskGenerativeAIOutputCached',
  'RealtimeMinute',
  'RealtimeAudioInput', 'RealtimeAudioInputCached', 'RealtimeAudioOutput',
  'RealtimeTextInput', 'RealtimeTextInputCached', 'RealtimeTextOutput'
];

export enum AiModelPriceType {
  RealtimeChargedByToken = 'RealtimeChargedByToken',
  RealtimeChargedByMinute = 'RealtimeChargedByMinute',
  ChatCompletion = 'ChatCompletion'
}

//display names for enum AiAssistantModelActionType
export const AiModelActionTypeNames: { [key: string]: string } = {
  AskGenerativeAI: 'Ask Generative AI',
  AIAgent: 'AI Agent'
};

export interface IAiModelPriceRequest {
  prices: IAIPriceList[];
  removedCodes: string[];
  llmEngine: string;
  //AiAssistantModel.Codes value for the llmEngine
  code: string;
  actionTypes: string[];
  minimumTokens: number;
  maximumTokens: number;
  hasReasoning: boolean;
  reasoningEffortOptions: string[];
  reasoningSummaryOptions: string[];
}

export interface IAiModelSettings {
  name: string;
  modelType: string;
  subType: string;
  llmEngine: string;
  //AiAssistantModel.Codes value for the llmEngine
  code: string;
  actionTypes: string[];
  minimumTokens: number;
  maximumTokens: number;
  hasReasoning: boolean;
  reasoningEffortOptions: string[];
  reasoningSummaryOptions: string[];
}

export interface IAiModelSettingsResponse {
  models: IAiModelSettings[];
  llmEngines: string[];
  //allowed values, from the backend enums
  actionTypes: string[];
  reasoningEffortOptions: string[];
  reasoningSummaryOptions: string[];
}

export interface IAiModelPriceResponse {
  success: boolean;
  errorMessage: string;
}

export interface IAiModelPriceGroup {
  model: string;
  priceType: AiModelPriceType;
  llmEngine: string;
  //AiAssistantModel.Codes value for the llmEngine
  code: string;
  //values from enum AiAssistantModelActionType
  actionTypes: string[];
  //AiAssistantModel.MinimumTokens
  minimumTokens: number;
  //AiAssistantModel.HasReasoning
  hasReasoning: boolean;
  //AiAssistantModel.MaximumTokens
  maximumTokens: number;
  reasoningEffortOptions: string[];
  reasoningSummaryOptions: string[];
  interval: number;
  list: IAIPriceList[];
}
